import { faClose } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

export const VoucherHeader = ({
  onModalClose,
}: {
  onModalClose: () => void;
}) => {
  return (
    <section className="gg-relative gg-px-5 sm:gg-px-6 lg:gg-px-8 gg-pt-9 lg:gg-pt-12 gg-col-span-9 gg-flex gg-flex-col  gg-text-slate-800">
      {/* Close button */}
      <button
        onClick={onModalClose}
        className="gg-absolute gg-right-3 gg-top-3.5 md:gg-right-5 md:gg-top-5 gg-grid gg-place-items-center lg:gg-right-3.5 lg:gg-top-5 gg-cursor-pointer gg-text-zinc-400 hover:gg-text-zinc-900 hover:gg-bg-gray-300 gg-w-5 gg-h-5 gg-border-none gg-rounded-full gg-bg-gray-200"
      >
        <FontAwesomeIcon icon={faClose} size="sm" />
      </button>
      {/* Close button */}
      <h1 className="gg-w-full gg-text-2xl gg-font-bold gg-leading-8 ">
        Heb je een cadeaukaart of voucher?
      </h1>
      <p className="gg-mt-2.5 gg-w-full gg-text-base gg-leading-6 ">
        Vul hier je code in. De totaalprijs wordt direct aangepast.
      </p>
    </section>
  );
};
